var Interface = require('../core');
var _ = require('lodash');

var forceToString = function forceToString(val) {
  return (_.isEmpty(val))
    ? ''
    : val.toString();
};

var standardTypeDefaults = {
  // @deprecated
  'regexp': function () {
    return (new RegExp());
  },
  'null': null,
  'undefined': undefined
};

_.each(standardTypeDefaults, function (defaultValue, standardType) {

  this.type(standardType, {
    defaultValue: function () {
      return defaultValue;
    },
    isOfType: function (val, req) {
      return (this.discoverType(val) === req.type);
    }
  });

}, Interface);

Interface.type('string', {

  defaultValue: '',
  convertToSource: forceToString,
  isOfType: function (val, req) {

    var rules = req.rules,
      len = (!!val && val.length)
        ? val.length
        : 0;

    if (!_.isString(val)) {
      return false;
    }

    else if (rules && rules.min && len < rules.min) {
      return false;
    }

    else if (rules && rules.max && len > rules.max) {
      return false;
    }

    return _.isString(val);
  },
  convertToSync: function (val) {
    return (_.isUndefined(val) || _.isNull(val))
      ? val
      : val + '';
  }
});

Interface.type('boolean', {
  isOfType: function (val, req) {
    return val === true || val === false;
  },
  afterConvertToSync: function (val) {
    return !!val;
  }
});

Interface.type('tri-state', {
  isOfType: function (val, req) {
    return _.isUndefined(val) || _.isNull(val) || _.isBoolean(val);
  },
  afterConvertToSync: function (val) {
    return (_.isNull(val))
      ? undefined
      : val;
  }
});

/*
 rules: {
 trueValue:'Y',
 falseValue:'N'
 }
 */

(function (Interface) {

  var defaultRules = {
      yN: {
        trueValue: 'Y',
        falseValue: 'N'
      },
      yesNo: {
        trueValue: 'yes',
        falseValue: 'no'
      },
      tF: {
        trueValue: 't',
        falseValue: 'f'
      },
      trueFalse: {
        trueValue: 'true',
        falseValue: 'false'
      },
      number: {
        trueValue: 1,
        falseValue: 0
      }
    },
    defaultConversions = {
      'n': {
        value: false,
        rules: defaultRules.yN
      },
      'no': {
        value: false,
        rules: defaultRules.yesNo
      },
      'f': {
        value: false,
        rules: defaultRules.tF
      },
      'false': {
        value: false,
        rules: defaultRules.trueFalse
      },
      'y': {
        value: true,
        rules: defaultRules.yN
      },
      'yes': {
        value: true,
        rules: defaultRules.yesNo
      },
      't': {
        value: true,
        rules: defaultRules.tF
      },
      'true': {
        value: true,
        rules: defaultRules.trueFalse
      }
    };

  Interface.type('smart-boolean', {
    convertToSource: function (val, req) {

      var falseValue = (!!req.rules && !!req.rules.falseValue)
          ? req.rules.falseValue
          : 'N',
        trueValue = (!!req.rules && !!req.rules.trueValue)
          ? req.rules.trueValue
          : 'Y';

      if (val === true) {
        return trueValue;
      }
      else if (val === false) {
        return falseValue;
      }
      else {
        return null;
      }
    },
    convertToSync: function (sourceProp, req) {

      if (_.isString(sourceProp)) {

        sourceProp = sourceProp.toLowerCase();

        if (!!req.rules) {

          if (req.rules.falseValue.toLowerCase() === sourceProp) {
            sourceProp = false;
          }
          else if (req.rules.trueValue.toLowerCase() === sourceProp) {
            sourceProp = true;
          }
        }
        else {

          var conversionClassification = _.find(defaultConversions, function (v, k) {
            return k === sourceProp;
          });

          if (!!conversionClassification) {
            sourceProp = conversionClassification.value;
            req.rules = conversionClassification.rules;
          }
        }
      }
      else if (_.isNumber(sourceProp)) {
        sourceProp = (parseInt(sourceProp) > 0);
        req.rules = defaultRules.number
      }

      if (!_.isBoolean(sourceProp)) {
        sourceProp = undefined;
      }

      return sourceProp;
    },
    isOfType: function (val) {
      return val === true || val === false;
    },
    afterConvertToSync: function (val) {
      return !!val;
    }
  });

})(Interface);

(function (Interface) {

  var isFunction = /^\s*function[a-zA-Z0-9\s]*\(.*\)\s*{.*};?\s*$/;
  var functionDefault = (function NOOP() {
    return 'noop';
  });

  Interface.type('function', {
    defaultValue: function (f) {
      return f || functionDefault;
    },
    isOfType: function (val) {
      return isFunction.test(val);
    },
    convertToSource: forceToString,
    afterConvertToSync: function (val) {

      var fn;

      try {

        if (!isFunction.test(val)) {
          throw Error('will be caught immediately');
        }

        fn = eval('(' + val + ')');
      }
      catch (e) {
        fn = functionDefault;
      }
      finally {
        return fn;
      }
    }
  });

}(Interface));

Interface.type('regexp').convertToSource = forceToString;



// WEBPACK FOOTER //
// simple.js